/*
 * @deprecated Use @mentimeter/i18n/constants instead
 */
module.exports = {
  CACHE_REVALIDATE_TIME: 15 * 60, // 15 minutes
  DEFAULT_LOCALE: 'en-US',
  LOCALES: ['en-US', 'pt-BR', 'es-ES', 'de-DE'],
};
